import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_alert_on_footprint_eventsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { days_created: number, status_ids?: number[], type_ids?: number[], min_count?: number, max_count?: number, type_name?: string, debug?: boolean, to?: string, cc?: string, bcc?: string }): Promise<{ results?: any[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.days_created)) {
      $missingRequiredInParams.push('\'days_created\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

